// Offline support configuration.
//
// Offline is on by default for everyone. The URL override is kept
// only as an emergency switch — visit any page with ?offline=0 once
// to opt out (persists across sessions in localStorage), and
// ?offline=1 to opt back in.

const DISABLE_KEY = 'songbook-offline-disabled'

function resolveFlag(): boolean {
  if (typeof window === 'undefined') return true

  try {
    const params = new URLSearchParams(window.location.search)
    const override = params.get('offline')
    if (override === '0') {
      window.localStorage.setItem(DISABLE_KEY, '1')
    } else if (override === '1') {
      window.localStorage.removeItem(DISABLE_KEY)
    }
    return window.localStorage.getItem(DISABLE_KEY) !== '1'
  } catch {
    return true
  }
}

// Resolved once at module load (after URL override check).
export const OFFLINE_ENABLED = resolveFlag()

// IndexedDB identifiers
export const OFFLINE_DB_NAME = 'songbook-offline'
export const OFFLINE_DB_VERSION = 1

// Cache API names
export const CACHE_IMAGES = 'songbook-images-v1'
export const CACHE_AUDIO = 'songbook-audio-v1'

// Quota thresholds (in MB) used by later phases
export const OFFLINE_QUOTA_WARN_MB = 500
export const OFFLINE_QUOTA_CRITICAL_MB = 100

// Force-offline: user-activated mode that skips all cloud calls so
// the app feels instant when the user knows they'll have no signal
// (e.g. rehearsal room in a basement). Persisted in localStorage.
const FORCE_OFFLINE_KEY = 'songbook-force-offline'

export function isForceOffline(): boolean {
  try {
    return window.localStorage.getItem(FORCE_OFFLINE_KEY) === '1'
  } catch {
    return false
  }
}

export function setForceOffline(on: boolean): void {
  try {
    if (on) {
      window.localStorage.setItem(FORCE_OFFLINE_KEY, '1')
    } else {
      window.localStorage.removeItem(FORCE_OFFLINE_KEY)
    }
  } catch { /* ignore */ }
}

// Returns true when the app should treat itself as offline — either
// because the browser genuinely has no connection or the user forced
// offline mode via the toggle.
export function isEffectivelyOffline(): boolean {
  return !navigator.onLine || isForceOffline()
}
